(function () {
  'use strict';

  var MOBILE = '(max-width: 768px)';

  function buildSwiper(section) {
    var el = section.querySelector('.shop-genesis__swiper');
    if (!el || typeof Swiper === 'undefined') return null;

    var id = section.dataset.sectionId;

    var instance = new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 8,

      observer: true,
      observeParents: true,
      observeSlideChildren: true,

      breakpoints: {
        480: { slidesPerView: 2.2, spaceBetween: 16 },
        600: { slidesPerView: 2.8, spaceBetween: 16 }
      }
    });

    var nextBtn = document.getElementById('sg-next-' + id);
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (instance && !instance.destroyed) instance.slideNext();
      });
    }

    var imgs = el.querySelectorAll('img');
    var pending = imgs.length;

    if (pending) {
      imgs.forEach(function (img) {
        if (img.complete) {
          pending--;
          return;
        }
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      });
    }

    function done() {
      pending--;
      if (pending <= 0 && instance && !instance.destroyed) {
        instance.update();
      }
    }

    window.addEventListener('load', function () {
      if (instance && !instance.destroyed) instance.update();
    });

    return instance;
  }

  function initSection(section) {
    var instance = null;
    var mq = window.matchMedia(MOBILE);

    function sync() {
      if (mq.matches && !instance) {
        instance = buildSwiper(section);
      } else if (!mq.matches && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    }

    sync();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-shop-genesis]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
